import React from "react";
import Box from "@mui/material/Box";
import { ProductList } from "@/components/organisms/ProductList";
import { PreorderForm } from "@/components/organisms/PreorderForm";
import { useAppSelector } from "@/core/hooks";
import { selectIsReadOnly } from "@/core/app/selectors";

/**
 * Preorder Page Component
 *
 * Simple page that displays the ProductList component using brandId and pointId
 * from Redux state. DataLoader handles URL parameter extraction and initialization.
 *
 * When isReadOnly is true, hides the product catalog and shows only the cart
 * positioned on the right side of the viewport.
 */
export const PreorderPage: React.FC = () => {
  const { brandId, pointId } = useAppSelector((state) => state.app);
  const isReadOnly = useAppSelector(selectIsReadOnly);

  // Модалку корзины на EDIT_ORDER открывает useOrderRestore: прежний триггер
  // читал lastAction, а тот слайс уходит вместе с сагой.

  // If required parameters are missing, show error message
  if (!brandId || !pointId) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          p: 3,
          textAlign: "center",
        }}
      >
        <Box>
          <h2>Ошибка параметров</h2>
          <p>Не указаны обязательные параметры brandId и pointId</p>
          <p>Пример: /preorder?brandId=your-brand-id&pointId=your-point-id</p>
        </Box>
      </Box>
    );
  }

  // ReadOnly mode: show only the cart, positioned on the right
  if (isReadOnly) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "flex-start",
          backgroundColor: "background.default",
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: 480 },
            maxWidth: "100%",
            height: "100vh",
            position: "relative",
            backgroundColor: "background.paper",
            boxShadow: 3,
          }}
        >
          <PreorderForm
            onEditItem={() => {}}
            onAddMore={() => {}}
            onItemSelect={() => {}}
          />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "background.default",
      }}
    >
      <ProductList
        showCategoryNavigation={true}
        data-testid="preorder-productlist"
      />
    </Box>
  );
};
